import React from 'react';
import navigationConfig from './pricingNavigationConfig';
import RenderNavItems from '../common/renderNavItems';

const PricingSidebarOptions = () => {
  return <RenderNavItems config={navigationConfig} />;
};
export default PricingSidebarOptions;
